import { render, staticRenderFns } from "./EditModule.vue?vue&type=template&id=44d1f4df&scoped=true"
import script from "./EditModule.vue?vue&type=script&lang=js"
export * from "./EditModule.vue?vue&type=script&lang=js"
import style0 from "./EditModule.vue?vue&type=style&index=0&id=44d1f4df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d1f4df",
  null
  
)

export default component.exports